import { render, staticRenderFns } from "./PopularUsers.vue?vue&type=template&id=8e448d26&scoped=true&"
import script from "./PopularUsers.vue?vue&type=script&lang=js&"
export * from "./PopularUsers.vue?vue&type=script&lang=js&"
import style0 from "./PopularUsers.vue?vue&type=style&index=0&id=8e448d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e448d26",
  null
  
)

export default component.exports